export default class HelperGoogleAnalytics {
	static TrackEvent(eventName, eventData) {
		try {

			if (typeof analyticsWrapper !== 'undefined') {
				// eslint-disable-next-line no-undef
				analyticsWrapper.track(eventName, eventData);
			}
		} catch (e) {
			console.error(e);
		}
	}

	static GetAnalyticsEventLabelSimple(taxonomy) {
		if (!taxonomy) return '';
		const {category, name} = taxonomy;


		let eventLabel = 'Product Category/' + category;
		eventLabel = eventLabel + ' - Product Name/' + name;
		return eventLabel;
	}

	static GetAnalyticsEventLabel(taxonomy, isNewService) {
		if (!taxonomy) return '';
		const {category, brand, name} = taxonomy;
		const variant = isNewService === true ? 'New' : 'Renew';

		const checkoutStep = sessionStorage.getItem('checkoutStep');


		let eventLabel = 'Product Category/' + category;
		if (checkoutStep) {
			eventLabel = eventLabel + ' - Checkout/Step ' + checkoutStep;
		}
		eventLabel = eventLabel + ' - Product Brand/' + brand;
		eventLabel = eventLabel + ' - Product Name/' + name;
		eventLabel = eventLabel + ' - Product Variant/' + variant;
		return eventLabel;
	}

	static TrackServicePriceSelectorOpen(taxonomy, isNewService) {
		if (!taxonomy) return;
		const eventData = {
			event_category: 'InCart Actions',
			event_label: this.GetAnalyticsEventLabel(taxonomy, isNewService),
			non_interaction: true
		};
		HelperGoogleAnalytics.TrackEvent('Periods selector - Open', eventData);
	}

	static TrackServicePriceSelectorClose(taxonomy, isNewService, selectedTerm) {
		if (!taxonomy) return;
		let eventLabel = this.GetAnalyticsEventLabel(taxonomy, isNewService);
		eventLabel = eventLabel + ' - Product Term/' + selectedTerm;
		const eventData = {
			event_category: 'InCart Actions',
			event_label: eventLabel,
			non_interaction: true
		};
		HelperGoogleAnalytics.TrackEvent('Periods selector - Plan selected', eventData);
	}

	static TrackContinueButton(variant) {
		HelperGoogleAnalytics.TrackNonInteractionEvent('Continue Button clicked', 'InCart Actions', 'Variant/' + variant);

	}


	static TrackNonInteractionEvent(eventName, eventCategory, eventLabel) {
		const eventData = {
			event_category: eventCategory,
			event_label: eventLabel,
			non_interaction: true
		};
		HelperGoogleAnalytics.TrackEvent(eventName, eventData);

	}


}
